import { api, ApiResponse } from './api'

export interface MenuItemData {
  menu_no: string;
  menu_nm: string;
  menu_eng_abb_nm: string;
  up_menu_no: string | null;
  lnkg_addr: string;
  sort_sn: number;
  lvl: number;
  menu_type_cd: string;
  gnb_use_yn: string;
  smap_use_yn: string;
  lnkg_tget_cd: string;
  sns_type_cd: string;
  use_yn: string;
  icon_nm: string | null;
  pic_mbr_no_vl: string | null;
  children?: MenuItemData[];
}

/**
 * flat 목록을 tree 구조로 변환
 */
function buildMenuTree(flatList: MenuItemData[]): MenuItemData[] {
  const map = new Map<string, MenuItemData>()
  const roots: MenuItemData[] = []

  // 1) 모든 항목을 map에 등록
  for (const item of flatList) {
    map.set(item.menu_no, { ...item, children: [] })
  }

  // 2) parent-child 연결
  for (const item of flatList) {
    const node = map.get(item.menu_no)!
    if (item.up_menu_no && map.has(item.up_menu_no)) {
      map.get(item.up_menu_no)!.children!.push(node)
    } else {
      roots.push(node)
    }
  }

  return roots
}

export const menuApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * 홈페이지 구분(F/B/E)별 GNB 메뉴 (tree 구조). 인자 없으면 F 반환.
     */
    getFrontNavMenus: builder.query<MenuItemData[], { hmpg_se_cd?: string } | void>({
      query: (arg) => {
        const code = (arg && 'hmpg_se_cd' in arg && arg.hmpg_se_cd) || 'F'
        return `/public/menu/nav?hmpg_se_cd=${encodeURIComponent(code)}`
      },
      transformResponse: (response: ApiResponse<MenuItemData[]>) =>
        buildMenuTree(response.data || []),
    }),
  }),
})

export const { useGetFrontNavMenusQuery } = menuApi
